export const BONUS = 'Bonus';
export const ADD_BONUS = 'Add Bonus';
export const EDIT_BONUS = 'Edit Bonus';

export const BONUS_PAGES = {
  TABLE: 'table',
  FORM: 'form',
};

// tooltip names
export const BACK = 'Back to Menu';
export const ENABLE_BONUS = 'Enable Bonus';
